export const convertDateToIso = (valueDate: string): string => {
    let date = new Date(valueDate)
    let month = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    return `${[date.getFullYear(), month, day].join("-")}T00:00:00.000Z`
}

export const  getVariableValue = (value: any, arrayPosition: number): string => {
    let tmpValue: string = "";
    if (value !== undefined) {
        if (value[arrayPosition]) {
            tmpValue = value[arrayPosition].toString();
        }
    }
    return tmpValue;
}

export const activeFiltersToString = (filterTypeUi: string | undefined, userValues: any , filterValues: any): string => {
    let finalValue = "";
    if(filterTypeUi == "MultiSelectBox"){
        if(userValues && filterValues){
            const selectedValues = filterValues.filter(function(filterValue: any) {
                return Object(userValues).some(function(userValue: any) {
                    return filterValue.id == userValue.id || filterValue.id == userValue;
                });
            })
            Object(selectedValues).map((selectedValue: {id: any, value: any}) => {
                finalValue += `${selectedValue.value}, `;
            })
        }
    }
    else{
        finalValue = userValues;
    }
    return finalValue ? finalValue.toString(): "";
}

export const isIsoDate = (date: string):boolean => {
    if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(date))
        return false;
    else
        return true;
}
